module.exports = __webpack_public_path__ + "static/media/29COICT8.129c7137.jpg";